import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-so-happy',
  templateUrl: './so-happy.component.html',
  styleUrls: ['./so-happy.component.scss']
})
export class SoHappyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/so-happy/so-happy.component.ts